import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"

import { ListBox } from "components"

import ListItem from "./_ListItem"

function ProductList({ showFilters, subtitle, title }) {
  const [activeFilter, setActiveFilter] = useState("all")

  const data = useStaticQuery(PRODUCT_QUERY)
  const productCategories = data?.allContentfulProductCategory?.nodes
  const productSubcategories = data?.allContentfulProductSubcategory

  return (
    <section
      data-slice="ProductList"
      className="pt-16 pb-16 md:pt-24 wrapper default-grid gap-y-16 md:gap-y-24 md:pb-24"
    >
      <div className="space-y-8 text-center col-span-full">
        <div className="space-y-4 md:space-y-8">
          {title && <h2 className="h1 text-darkPurple">{title}</h2>}
          {subtitle && <p className="lead-copy text-darkNavy">{subtitle}</p>}
        </div>
        {showFilters && (
          <div className="flex justify-center">
            <div className="max-w-sm">
              <ListBox
                options={[
                  {
                    value: "all",
                    label: "All capabilities",
                  },
                  ...productCategories?.map(({ name, slug }, index) => ({
                    value: slug,
                    label: name,
                  })),
                ]}
                value={activeFilter}
                onChange={value => {
                  setActiveFilter(value)
                }}
              />
            </div>
            {/* <Select
              className="max-w-sm"
              value={activeFilter}
              onChange={e => {
                setActiveFilter(e.target.value)
              }}
            >
              <option value="">All capabilities</option>
              {productCategories?.map(({ name, slug }, index) => (
                <option key={`filterOption-${index}`} value={slug}>
                  {name}
                </option>
              ))}
            </Select> */}
          </div>
        )}
      </div>
      <ul className="space-y-8 col-span-full md:col-span-6 md:col-start-4">
        {productSubcategories?.nodes
          ?.filter(
            a => activeFilter === "all" || a?.category?.slug === activeFilter
          )
          ?.map((productSubcategory, i) => (
            <ListItem {...productSubcategory} key={`subcategory--${i}`} />
          ))}
      </ul>
    </section>
  )
}

export default ProductList

const PRODUCT_QUERY = graphql`
  query ProductSubcategories($order: [SortOrderEnum] = ASC) {
    allContentfulProductCategory {
      nodes {
        name
        slug
      }
    }
    allContentfulProductSubcategory(sort: { order: $order, fields: title }) {
      nodes {
        title
        slogan
        slug
        category {
          slug
          name
        }
        menuPhoto {
          title
          description
          gatsbyImageData(width: 180, aspectRatio: 1, resizingBehavior: PAD)
          file {
            contentType
            url
          }
        }
      }
    }
  }
`
